webpackJsonp([215659791829337],{

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactForm = __webpack_require__(249);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactEs = function ContactEs(props) {
	  var lang = props.pathContext.langKey;
	  var items = props.data.allContactFormJson.edges;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page contact' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Contactanos | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Preguntas frecuentes sobre el alquiler de autos. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/contact'
	      }]
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Cont\xE1ctenos'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'block-first' },
	        _react2.default.createElement(_ContactForm2.default, { lang: lang, items: items })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'block-second' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Servicio las 24 horas, los 365 d\xEDas del a\xF1o'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'mail', href: 'mailto:reserve@budget.com.ni' },
	          'mailto:reserve@budget.com.ni'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:+50522559000' },
	          ' +505 2255-9000'
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = ContactEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-es-js-bbed7c2e319d18c776e9.js